<div class="ticket-card-pay">
    <upp-dialog-header>
        <ion-header>
            <ion-toolbar color="warning">
                <ion-title slot="start">{{tr('@ticket_paycard_title', [ price(AmountToPay), tr('@currency') ])}}</ion-title>
                <ion-buttons slot="end">
                    <ion-button uppDataid="ticketcash-close-button" (click)="OnCloseClick()">
                        <ion-icon slot="icon-only" name="close-outline"></ion-icon>
                    </ion-button>
                </ion-buttons>
            </ion-toolbar>
        </ion-header>
    </upp-dialog-header>

    <upp-dialog-content>
        <ion-item lines="none" class="ticket-card-pay__confirm">
            <ion-label>{{tr('@ticket_paycard_confirm')}}</ion-label>
        </ion-item>
    </upp-dialog-content>

    <upp-dialog-footer class="ticket-card-pay__footer">
        <ion-button uppDataid="ticketcard-submit-button" size="large" expand="block" color="success" (click)="OnAcceptClick()">
            {{tr('@ticket_paycard_accept')}}
        </ion-button>
        <ion-button uppDataid="ticketcard-cancel-button" expand="block" fill="clear" color="success" (click)="OnCloseClick()">
            {{tr('@ticket_paycard_cancel')}}
        </ion-button>
    </upp-dialog-footer>
</div>
